module.exports = __webpack_public_path__ + "img/skip-button.620a8bde.png";